export const dlPush = (obj) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
};

// GTM's data layer merges arrays index by index across pushes, so a shorter
// content_ids would keep the tail of the previous list (e.g. a product view
// after a 20-item region view). Clear the key before pushing the new event.
export const dlPushContent = (obj) => {
    dlPush({ content_ids: null });
    dlPush(obj);
};
